module.exports = __webpack_public_path__ + "static/img/HeathShaw.441631c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/HeathShaw.jpg
// module id = fHBD
// module chunks = 0